export default function TasksSolved() {
  const tasks = [
    { icon: 'ri-sword-line', title: 'Сложные переговоры', desc: 'Многоуровневые сделки, длинные циклы, множественные stakeholders' },
    { icon: 'ri-emotion-line', title: 'Давление клиента', desc: 'Работа с агрессивными тактиками, ультиматумами и манипуляциями' },
    { icon: 'ri-shield-check-line', title: 'Защита цены', desc: 'Аргументация стоимости без скидок, демонстрация ценности продукта' },
    { icon: 'ri-percent-line', title: 'Работа без скидок', desc: 'Как сохранить маржинальность и не уступить в цене' },
    { icon: 'ri-scales-line', title: 'Аргументация', desc: 'Построение логических цепочек, работа с фактами и цифрами' },
    { icon: 'ri-store-line', title: 'Переговоры с закупщиками', desc: 'Профессиональные закупщики: тактики, критерии, тендеры' },
    { icon: 'ri-organization-chart', title: 'Переговоры между подразделениями', desc: 'Снятие барьеров, согласование интересов, кросс-функциональное взаимодействие' },
    { icon: 'ri-chat-voice-line', title: 'Внутренние переговоры', desc: 'Переговоры с коллегами, руководством, смежными отделами' },
    { icon: 'ri-mental-health-line', title: 'Эмоциональное давление', desc: 'Управление эмоциями в стрессовых переговорных ситуациях' },
    { icon: 'ri-error-warning-line', title: 'Тупиковые переговоры', desc: 'Выход из тупика, переформатирование повестки, возврат к диалогу' },
    { icon: 'ri-hand-heart-line', title: 'Управление конфликтом', desc: 'Конфликт как ресурс: превращение противостояния в сотрудничество' },
    { icon: 'ri-link', title: 'Долгосрочные отношения', desc: 'Построение партнёрств, основанных на доверии и взаимной выгоде' },
  ];

  return (
    <section id="tasks" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие задачи решает <strong>тренинг по переговорам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Каждая компания сталкивается с уникальными вызовами в переговорах. Мы решаем конкретные задачи — от сложных B2B-переговоров до внутренних коммуникаций между подразделениями.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {tasks.map((task, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-3 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${task.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-1.5">{task.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{task.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}